<div class="questionContainer">
  <div class="titleContainer">
    <div class="title">
      {{ 'questions.cogres.title' | translate }}
    </div>
  </div>
  <div class="contentContainer">
    @if (viewMode === ViewMode.start) {
      <div class="startInstructionsContainer">
        <div class="explainText">
          {{ 'questions.cogres.explain' | translate }}
        </div>
        <div (click)="startQuestion()" class="startButton ctaBtn">
          {{ 'common.buttons.start' | translate }}
        </div>
      </div>
    }
    @if (viewMode === ViewMode.questionning) {
      <div class="counterContainer">
        <div class="counter">{{ formattedTime }}</div>
      </div>
    }
    <div class="questionContentContainer">
      <div class="question">{{ question.question_content }}</div>
    </div>
    @if (viewMode === ViewMode.questionning) {
      <div
        (click)="toggleAnswer()"
        class="answerContainer"
        [class.active]="pickedAnswers[aIndex] === '1'"
        [class.correct]="answerButtonState === 'correct'"
        [class.incorrect]="answerButtonState === 'incorrect'"
      >
        <div class="answer">{{ question.answers[aIndex] }}</div>
      </div>
    }
  </div>
</div>
